/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetDownloadIcon16Light } from './NetDownloadIcon16Light';
import { NetDownloadIcon16Regular } from './NetDownloadIcon16Regular';
import { NetDownloadIcon16Solid } from './NetDownloadIcon16Solid';
import { NetDownloadIcon20Light } from './NetDownloadIcon20Light';
import { NetDownloadIcon20Regular } from './NetDownloadIcon20Regular';
import { NetDownloadIcon20Solid } from './NetDownloadIcon20Solid';
import { NetDownloadIcon24Regular } from './NetDownloadIcon24Regular';
import { NetDownloadIcon24Solid } from './NetDownloadIcon24Solid';
import { NetDownloadIcon32Regular } from './NetDownloadIcon32Regular';
import { NetDownloadIcon64Regular } from './NetDownloadIcon64Regular';
var sizes = {
    16: {
        light: NetDownloadIcon16Light,
        regular: NetDownloadIcon16Regular,
        solid: NetDownloadIcon16Solid,
    },
    20: {
        light: NetDownloadIcon20Light,
        regular: NetDownloadIcon20Regular,
        solid: NetDownloadIcon20Solid,
    },
    24: {
        regular: NetDownloadIcon24Regular,
        solid: NetDownloadIcon24Solid,
    },
    32: {
        regular: NetDownloadIcon32Regular,
    },
    64: {
        regular: NetDownloadIcon64Regular,
    },
};
export var NetDownloadIcon = forwardRef('NetDownloadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
